module.exports = __webpack_public_path__ + "static/img/label-icon-en.875d4567.png";